import { render, staticRenderFns } from "./VideoEnlarge.vue?vue&type=template&id=f1d6d604&scoped=true&"
import script from "./VideoEnlarge.vue?vue&type=script&lang=js&"
export * from "./VideoEnlarge.vue?vue&type=script&lang=js&"
import style0 from "./VideoEnlarge.vue?vue&type=style&index=0&id=f1d6d604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d6d604",
  null
  
)

export default component.exports